import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import { HeroVideoBackground } from './HeroVideoBackground';
import { useCopy } from './copy/copyMode';
import { WaitlistCTA } from './WaitlistCTA';
const LOGOS = ['Shopify', 'Notion', 'Ramp', 'Tonic', 'Linear', 'Ember', 'Stripe', 'Entropy Studios', 'Figma', 'Larger Caveman', 'Mercury', 'Vercel'];
export function MarketingHero() {
  const copy = useCopy();
  return <section className="relative min-h-screen w-full overflow-hidden font-body bg-[#FAF8F4]" data-id="element-3838" data-mp="1a66bolyjrlj6">
      {/* Subtle halftone dot-grid texture across the surface */}
      <div aria-hidden="true" className="cream-grid z-0" data-id="element-3839" data-mp="157223u7pnlsb" />

      <HeroVideoBackground data-id="element-3840" data-mp="108ii3zcogk2l" />

      <div className="relative z-20 min-h-screen flex flex-col justify-start md:justify-center" data-id="element-3841" data-mp="109a18ap38pbz">
        <div className="w-full max-w-[1280px] mx-auto flex flex-col justify-center px-6 md:px-10 pt-28 md:pt-32 pb-16 md:pb-32 lg:pb-20" data-id="element-3842" data-mp="2zkb6j7legh3p">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-mono text-xs sm:text-sm font-medium uppercase tracking-[0.28em] text-neutral-500 mb-4 md:mb-5 block" data-id="element-3843" data-mp="vw63sd47g6y4">
            {copy.marketingHero.eyebrow}
          </motion.span>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="font-title font-medium text-[#2B211A] tracking-tight leading-[0.95] text-4xl sm:text-7xl lg:text-[96px] max-w-4xl" data-id="element-3844" data-mp="1emnrg3a6kccm">
            {copy.marketingHero.headline}
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="mt-8 md:mt-10 flex flex-col items-start gap-6" data-id="element-3845" data-mp="1xli5fa1tl8rq">
            <WaitlistCTA className="bg-[#EA580C] hover:bg-[#C2410C] text-white px-10 py-4 rounded-full font-bold text-lg transition-all duration-300 shadow-lg shadow-[#EA580C]/20 hover:shadow-xl hover:shadow-[#EA580C]/30 hover:-translate-y-0.5" data-id="element-3846" data-mp="2c64i10q7u8xm">
              Try Giga for free
            </WaitlistCTA>

            <div className="flex items-center gap-2 md:gap-3 text-neutral-500" data-id="element-3847" data-mp="1yajyc32nxmp5">
              <div className="flex gap-0.5 text-[#EA580C]" data-id="element-3848" data-mp="1taxo82i4smkk">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3.5 h-3.5 md:w-4 md:h-4" fill="currentColor" strokeWidth={0} data-id="element-3849" data-mp="1ohur5ke5auzm" />)}
              </div>
              <span className="font-mono text-xs md:text-sm tracking-tight" data-id="element-3850" data-mp="1jhgsuu2cizes">
                4.9 · loved by 1,200+ teams
              </span>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Faded auto-scrolling logo marquee pinned to the bottom */}
      <div className="absolute bottom-0 left-0 w-full z-30 pb-6 md:pb-8 pointer-events-none" data-id="element-3851" data-mp="15kac1516nas7">
        <p className="text-center font-mono text-[10px] sm:text-xs uppercase tracking-[0.28em] text-[#2B211A]/70 mb-4" data-id="element-3852" data-mp="3h6c6danmbmkc">
          Trusted by fast-moving teams
        </p>
        <div className="relative overflow-hidden" style={{
        WebkitMaskImage: 'linear-gradient(to right, transparent, black 12%, black 88%, transparent)',
        maskImage: 'linear-gradient(to right, transparent, black 12%, black 88%, transparent)'
      }} data-id="element-3853" data-mp="3r4rvj8334lr7">
          <motion.div className="flex w-max items-center gap-x-12 md:gap-x-16" animate={{
          x: ['-50%', '0%']
        }} transition={{
          duration: 55,
          repeat: Infinity,
          ease: 'linear'
        }} data-id="element-3854" data-mp="2yet4j75byejw">
            {[...LOGOS, ...LOGOS].map((logo, i) => <span key={`${logo}-${i}`} className="text-lg md:text-xl font-title font-bold tracking-tight text-[#2B211A]/55 whitespace-nowrap" data-id="element-3855" data-mp="3c9bzixiy2fs6" data-mpi={i}>
                {logo}
              </span>)}
          </motion.div>
        </div>
      </div>
    </section>;
}